const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .icon-feather-printer{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-feather-printer",
  d: "M9,11.05V3H22.8v8.05",
  transform: "translate(-1.4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-feather-printer",
  d: "M7.6,23.85H5.3A2.3,2.3,0,0,1,3,21.55V15.8a2.3,2.3,0,0,1,2.3-2.3H23.7A2.3,2.3,0,0,1,26,15.8v5.75a2.3,2.3,0,0,1-2.3,2.3H21.4",
  transform: "translate(0 -2.45)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-feather-printer",
  d: "M9,21H22.8v9.2H9Z",
  transform: "translate(-1.4 -4.2)"
}));
function SvgIconfeatherPrinter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherPrinter);
export default __webpack_public_path__ + "static/media/Icon feather-printer.0be55ae6.svg";
export { ForwardRef as ReactComponent };